import { CampaignStatus } from '@/types/campaign/campaign-status/campaign-status';
import { Mission } from '@/types/mission/mission-type';


interface CalculateTimeStatusParams {
    startDate: number;
    endDate: number;
    missions?: Mission[];
    isCompleted?: boolean;
    isClaimed?: boolean;
    isExChange?: boolean;
    isMission?: boolean;
    typeMission?: string;
    isContest: boolean;
}

export const calculateTimeStatus = ({
    startDate,
    endDate,
    missions = [],
    isCompleted = false,
    isClaimed = false,
    isExChange = false,
    isMission = false,
}: CalculateTimeStatusParams): CampaignStatus => {
    const now = Math.floor(Date.now() / 1000);

    if(!isClaimed && !isExChange && isCompleted && isMission) return 'pending_claim';

    if (isCompleted || isClaimed) return 'completed';

    if (missions.length > 0) {
        const hasEmptyProgress = missions.some(mission => 
            !mission.progress || mission.progress.length === 0
        );

        if (hasEmptyProgress) {
            if (now > endDate) return 'expired';
            if (now < startDate) return 'comingUp';
            return 'inCourse';
        }

        const allMissionsCompleted = missions.every(mission => 
            mission?.progress?.every(progressObj => {
                if (!progressObj.participant_progress) return false;

                const mainProgress = progressObj.participant_progress.current_progress;
                const mainCompleted = mainProgress >= progressObj.quantity;

                const childrenCompleted = progressObj?.children?.every(child => {
                    if (!child.participant_progress) return false;
                    const childProgress = child.participant_progress.current_progress;
                    return childProgress >= child.quantity;
                }) ?? true;

                return mainCompleted && childrenCompleted;
            })
        );

        if (allMissionsCompleted) {
            return 'completed';
        }
    }

    if (now > endDate) return 'expired';
    if (now < startDate) return 'comingUp';
    return 'inCourse';
};